export const unreadOffersCountKey = 'wyp_unreadOffersCount';
